
import styled from "styled-components";
import { theme } from "../../../../../helpers/theme";
import { StorageClass } from "../../../../../services/warehouses/warehouse-add/types";
import {WarehouseTestValue} from "../../../operator-subcontractors-add copy/index";

interface SingleWarehouseProps {
    actualInitialWarehouseAddValues: WarehouseTestValue;
    warehouseAddressID: string;
    warehouseID: string;
}
const getMagazineClassFromEnum = (type: number) => {
    switch (type) {
        case 0:
            return "A++";
        case 1:
            return "A+";
        case 2:
            return "A";
        case 3:
            return "B";
    }
};

export const SingleWarehouse = ({
    actualInitialWarehouseAddValues,
    warehouseAddressID,
    warehouseID,
}: SingleWarehouseProps) => {

    const dataWarehouse = [
        {
            title: "Kod magazynu",
            value: `${actualInitialWarehouseAddValues.kod_magazynu
                ? actualInitialWarehouseAddValues.kod_magazynu
                : "-"}`,
        },
        {
            title: "Opis",
            value: `${actualInitialWarehouseAddValues.opis
                ? actualInitialWarehouseAddValues.opis
                : "-"}`,
        },
        {
            title: "Powierzchnia",
            value: `${actualInitialWarehouseAddValues.powierzchnia_procentowa
                ? actualInitialWarehouseAddValues.powierzchnia_procentowa
                : "0"}%`,
        },
        {
            title: "Klasa magazynu",
            value: `${actualInitialWarehouseAddValues.klasa_magazynu
                ? getMagazineClassFromEnum(Number(actualInitialWarehouseAddValues.klasa_magazynu))
                : "-"}`,
        },
        {
            title: "Medyczny",
            value: `${actualInitialWarehouseAddValues.medyczny === false ? "Nie" : "Tak"} `,
        },
        {
            title: "Adres usługi",
            value: `${actualInitialWarehouseAddValues.adres_uslugi
                ? actualInitialWarehouseAddValues.adres_uslugi
                : "-"} `,
        },
        {
            title: "Login",
            value: `${actualInitialWarehouseAddValues.login
                ? actualInitialWarehouseAddValues.login
                : "-"} `,
        },
        {
            title: "Hasło",
            value: `${actualInitialWarehouseAddValues.haslo
                ? actualInitialWarehouseAddValues.haslo
                : "-"} `,
        },

    ];
    const addressWarehouse = [
        {
            title: "Kod pocztowy",
            value: `${actualInitialWarehouseAddValues.kod_pocztowy
                ? actualInitialWarehouseAddValues.kod_pocztowy
                : "-"} `,
        },
        {
            title: "Miejscowosc",
            value: `${actualInitialWarehouseAddValues.miejscowosc
                ? actualInitialWarehouseAddValues.miejscowosc
                : "-"} `,
        },
        {
            title: "Ulica",
            value: `${actualInitialWarehouseAddValues.ulica
                ? actualInitialWarehouseAddValues.ulica
                : "-"} `,
        },
        {
            title: "Numer budynku",
            value: `${actualInitialWarehouseAddValues.numer_budynku
                ? actualInitialWarehouseAddValues.numer_budynku
                : "-"} `,
        },
        {
            title: "Numer lokalu",
            value: `${actualInitialWarehouseAddValues.numer_lokalu
                ? actualInitialWarehouseAddValues.numer_lokalu
                : "-"} `,
        },
        {
            title: "Wojewodztwo",
            value: `${actualInitialWarehouseAddValues.wojewodztwo
                ? actualInitialWarehouseAddValues.wojewodztwo
                : "-"} `,
        },
        {
            title: "Kraj",
            value: `${actualInitialWarehouseAddValues.kraj
                ? actualInitialWarehouseAddValues.kraj
                : "-"} `,
        },
    ];

    return (
        <SingleWarehouseWrapper>
            <Data>
                {/* <Title>Magazyn dane</Title> */}
                {dataWarehouse.map((item) =>
                    <ItemWraper key={item.title}>
                        <ItemLabel>{item.title}:</ItemLabel>
                        <ItemValue>{item.value ? item.value : ""}</ItemValue>
                    </ItemWraper>
                )}
            </Data>
            <Address>
                {/* <Title>Magazyn Adress</Title> */}
                {addressWarehouse.map((item) =>
                    <ItemWraper key={item.title} >
                        <ItemLabel>{item.title}:</ItemLabel>
                        <ItemValue>{item.value}</ItemValue>
                    </ItemWraper>
                )}
            </Address>
        </SingleWarehouseWrapper>
    );
};
const SingleWarehouseWrapper = styled.div`
display: flex;
flex-direction: row;
justify-content: space-between;
padding: 32px;
@media (max-width:800px){
    flex-direction: column;
}
`;
const Data = styled.div`
display: flex;
flex-direction: column;
width:50%;
align-items: stretch;
-webkit-box-align: stretch;
place-content: stretch space-between;

@media (max-width:800px){
    width:100%;
}
`;
const Address = styled.div`
display: flex;
flex-direction: column;
width:50%;
align-items:stretch;
align-items: stretch;
-webkit-box-align: stretch;
place-content: stretch space-between;
padding-left:23px; 

@media (max-width:800px){
    width:100%;
    padding-left:0px; 
    margin-top:16px;
}
`;
const Title = styled.div`
font-family: ${theme.fonts.interRegular};
font-style: normal;
font-weight: ${theme.fontWeight.normal};
font-size: 14px;
line-height: 20px;
color: ${theme.colors.black_primaryText};
marin-bottom: 16px;
`;
const ItemWraper = styled.div`
display: flex;
flex-direction: row;
padding:3px 0px;
@media (max-width:400px){
    flex-direction: column;
    padding:0px 0px;
}
`;
const ItemLabel = styled.div`
font-family: ${theme.fonts.interRegular};
font-style: normal;
font-weight: 400;
font-size: 14px;
line-height: 20px;
color: ${theme.colors.gray01_secondaryText};
min-width: 150px;
`;
const ItemValue = styled.div`
font- family: ${theme.fonts.interRegular};
font-style: normal;
font-weight: 400;
font-size: 14px;
line-height: 20px;
color: ${theme.colors.black_primaryText};
padding-left:16px;
@media (max-width:400px){
    flex-direction: column;
    padding-left:16px;
}
`;

